export default {
  path: 'super',
  name: 'super',
  component: () => import('@/views/super/index.vue'),
  meta: {
    locale: '超管',
    requiresAuth: true,
    icon: 'icon-computer',
  },
  children: [
    {
      path: 'super-list', // The midline path complies with SEO specifications
      name: 'superList',
      component: () => import('@/views/super/list/index.vue'),
      meta: {
        locale: '超管',
        requiresAuth: true,
        roles: ['super'],
      },
    },
  ],
};
